export class ArrayHelper {

  static insertIntoPosition<T>(srcArray: T[], position: number, item: T) {
    srcArray.splice(position, 0, item);
  }
}
